export default __webpack_public_path__ + "static/media/XendFinanceLogo.a09cc706.svg";